var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container aside"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:item.icon,staticClass:"menu_item pointer",class:_vm.chooseNum === index ? 'is_active' : '',on:{"click":() => _vm.chooseItem(index, item)}},[_c('SvgComponent',{attrs:{"iconName":item.icon}}),_c('span',[_vm._v(_vm._s(item.title))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }